import { Box, ChevronDownIcon, ChevronUpIcon, Pressable, Text, useDisclose, View } from 'native-base';
import SummaryTableRow from '../SummaryTableRow';
import Functions from '../../../utils/Functions';
import { ColoredDifferenceAmount, ExpandableSummarySubRow } from '../index';
import React from 'react';
const ExpandableSummaryRow = _ref => {
  let {
    title,
    previous,
    current,
    difference,
    rows
  } = _ref;
  const {
    isOpen,
    onToggle
  } = useDisclose(true);
  return /*#__PURE__*/React.createElement(View, {
    key: title
  }, /*#__PURE__*/React.createElement(Pressable, {
    _pressed: {
      backgroundColor: '#FAFAFA'
    },
    onPress: onToggle,
    testID: "touchable-row"
  }, /*#__PURE__*/React.createElement(SummaryTableRow, {
    id: title
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 2,
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: title,
    accessibilityRole: "text"
  }, title), /*#__PURE__*/React.createElement(Box, {
    ml: 1,
    accessibilityLabel: isOpen ? 'collapse' : 'expand',
    accessibilityRole: "text"
  }, isOpen ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
    size: 'sm',
    color: "black.900"
  }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: 'sm',
    color: "black.900"
  }))), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: Functions.toUSD(previous),
    accessibilityRole: "text"
  }, Functions.toUSD(previous))), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: Functions.toUSD(current),
    accessibilityRole: "text"
  }, Functions.toUSD(current)), /*#__PURE__*/React.createElement(ColoredDifferenceAmount, {
    difference: difference,
    key: 'twenty-five',
    id: 'twenty-five'
  })))), /*#__PURE__*/React.createElement(Box, {
    testID: "expanded-summary-row"
  }, !isOpen || !rows || !Array.isArray(rows) ? null : rows.map(row => /*#__PURE__*/React.createElement(ExpandableSummarySubRow, {
    key: row.description,
    isOpen: true,
    title: row.description,
    difference: row.difference,
    current: row.currentPaymentAmount,
    previous: row.previousPaymentAmount
  }))));
};
export default ExpandableSummaryRow;
//# sourceMappingURL=index.js.map